/**
 * Textura do material (2026-10-15): a imagem do padrão (MDF, fita, laminado…)
 * ao lado da amostra de cor. Com textura, a lista e o detalhe mostram a
 * imagem; sem, continuam mostrando a cor.
 *
 * O arquivo fica no formulário (`textura_arquivo`) e sobe DEPOIS de salvar
 * o material — no cadastro novo ainda não existe produto para recebê-lo.
 * Quem sobe é `aplicarTextura` (services/estoque.js).
 */
import React, { useEffect, useRef, useState } from "react";
import { FiImage, FiTrash2, FiUpload } from "react-icons/fi";

import { Field, InlineHint } from "../styles";
import { erroDoArquivoDeTextura, EXTENSOES_TEXTURA } from "./textura";

export default function CampoTextura({ editando, setEditando }) {
  const entrada = useRef(null);
  const [erro, setErro] = useState("");
  const arquivo = editando.textura_arquivo || null;
  const [previa, setPrevia] = useState(null);

  useEffect(() => {
    if (!arquivo) { setPrevia(null); return undefined; }
    const url = URL.createObjectURL(arquivo);
    setPrevia(url);
    return () => URL.revokeObjectURL(url);
  }, [arquivo]);

  const atual = editando.textura_remover ? null : editando.textura_url;
  const imagem = previa || atual;

  function escolher(lista) {
    const novo = lista?.[0];
    if (!novo) return;
    const problema = erroDoArquivoDeTextura(novo);
    setErro(problema || "");
    if (problema) return;
    setEditando((p) => ({ ...p, textura_arquivo: novo, textura_remover: false }));
  }

  function remover() {
    setErro("");
    setEditando((p) => ({ ...p, textura_arquivo: null, textura_remover: Boolean(p.textura_url) }));
  }

  return (
    <Field style={{ gridColumn: "1 / -1" }}>
      Textura (imagem do padrão)
      <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
        <div
          aria-label={imagem ? "Prévia da textura" : "Sem textura"}
          role="img"
          style={{
            width: 72, height: 72, borderRadius: 12, flex: "0 0 auto",
            border: "1px solid var(--border-strong)", background: imagem ? `center / cover no-repeat url("${imagem}")` : "var(--surface-3)",
            display: "inline-flex", alignItems: "center", justifyContent: "center", color: "var(--ink-4)",
          }}
        >
          {imagem ? null : <FiImage size={22} aria-hidden="true" />}
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button type="button" className="btn btn--secondary btn--sm" onClick={() => entrada.current?.click()}>
            <FiUpload size={12} /> {imagem ? "Trocar imagem" : "Enviar imagem"}
          </button>
          {imagem ? (
            <button type="button" className="btn btn--secondary btn--sm" onClick={remover} style={{ color: "var(--danger-text)" }}>
              <FiTrash2 size={12} /> Remover
            </button>
          ) : null}
        </div>
        <input
          ref={entrada} type="file" accept={EXTENSOES_TEXTURA} hidden
          aria-label="Arquivo da textura"
          onChange={(e) => { escolher(e.target.files); e.target.value = ""; }}
        />
      </div>
      {erro ? <InlineHint style={{ color: "var(--danger-text)" }}>{erro}</InlineHint> : null}
      <InlineHint>
        JPG, PNG ou WEBP até 10 MB. Com textura, ela aparece no lugar da cor na lista e no detalhe.
        {arquivo ? " Será enviada ao salvar." : ""}
        {editando.textura_remover ? " Será removida ao salvar." : ""}
      </InlineHint>
    </Field>
  );
}
